module.exports = __webpack_public_path__ + "img/arrow-right.68c1d442.svg";